import * as React from 'react';

import { Button } from '../Button/Button';
import { SectionHeading } from '../SectionHeading/SectionHeading';
import { Stack } from '../Stack/Stack';
import { WrapList } from '../WrapList/WrapList';

import * as cs from './ButtonListSection.module.css';

interface Option {
  label: string;
  to?: string;
}

interface Props<T> {
  entries: T[];
  title: string;
  renderButton?: (option: T) => React.ReactNode;
}

export const ButtonListSection = <T extends Option>({
  entries,
  title,
  renderButton,
}: Props<T>) => (
  <Stack as="section" direction="vertical" gap={12}>
    <SectionHeading className={cs.title} as="h2">
      {title}
    </SectionHeading>

    <WrapList<T>
      entries={entries}
      getKey={(entry) => entry.label}
      renderItem={
        renderButton ||
        ((entry) => (
          <Button
            size="sm"
            variant="translucent"
            theme="current_text"
            to={entry.to}
            type={entry.to ? 'button' : 'tag'}
          >
            {entry.label}
          </Button>
        ))
      }
      columnGap={4}
      rowGap={8}
    />
  </Stack>
);
